// Crossroads (Mercury): every constellation counts one more branch toward
// its shape value (scoring/shape.ts counts the extra endpoint).
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const crossroads: AlignmentDef = {
  id: 'crossroads',
  planet: 'mercury',
  name: 'Crossroads',
  text: () => `Every constellation counts ${N.crossroadsBranches === 1 ? 'one extra branch' : `${N.crossroadsBranches} extra branches`}.`,
  extraEndpoints: N.crossroadsBranches,
};
